<template>
  <v-container fluid grid-list-md>
    <v-layout column wrap>
      <v-flex>
        <h1 class="display-3">Presupuesto Nº {{ $route.params.id }}</h1>
      </v-flex>
    </v-layout>
    <v-layout column wrap>
      <v-flex>
        <v-card raised>
          <v-card-title primary-title>
            <h3 class="headline mb-0">Datos del Presupuesto</h3>
          </v-card-title>
          <v-card-text>
            <v-layout row wrap>
              <v-flex v-if="p.usuario">
                <v-text-field prepend-icon="person" label="Usuario de carga" v-model="p.usuario.name"
                              readonly></v-text-field>
              </v-flex>
              <v-flex v-if="p.vendedor">
                <v-text-field prepend-icon="person" label="Vendedor" v-model="p.vendedor.name" readonly></v-text-field>
              </v-flex>
              <v-flex v-if="p.distribuidor">
                <v-text-field prepend-icon="person" label="Distribuidor autorizado" v-model="p.distribuidor.name"
                              readonly></v-text-field>
              </v-flex>
              <v-flex>
                <v-text-field prepend-icon="event" label="Fecha de ingreso" v-model="p.created_at"
                              readonly></v-text-field>
              </v-flex>
              <v-flex>
                <v-text-field prepend-icon="fa-credit-card" label="Condición de pago" v-if="p.condicion_pago"
                              v-model="p.condicion_pago.desig" readonly></v-text-field>
              </v-flex>

            </v-layout>
            <v-layout row wrap>
              <v-flex>
                <v-text-field prepend-icon="fa-truck" label="Flete" v-model="(p.flete)?p.flete.desig : p.flete"
                              readonly></v-text-field>
              </v-flex>
              <v-flex>
                <v-text-field prepend-icon="fa-truck" label="Puerta Salida" :value="puerta_salida"
                              readonly></v-text-field>
              </v-flex>
              <v-flex>
                <v-text-field label="Cotización" readonly
                              :value="(p.flete_cotizar)? 'COTIZAR FLETE' : 'NO COTIZAR FLETE'"></v-text-field>
              </v-flex>

            </v-layout>
            <v-layout row wrap>
              <v-flex xs12 sm12 md6>
                <v-text-field prepend-icon="place" label="Dirección de obra" v-model="p.dir_entrega"
                              readonly></v-text-field>
              </v-flex>
              <v-flex xs12 sm12 md6>
                <v-text-field prepend-icon="fa-truck" label="Contacto logístico" :value="p.logist_contacto"
                              readonly></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex>
                <v-text-field label="Moneda" v-if="p.moneda" v-model="p.moneda.desig" readonly></v-text-field>
              </v-flex>
              <v-flex>
                <v-text-field label="Tipo de cambio" v-model="p.tipo_cambio" readonly></v-text-field>
              </v-flex>
              <v-flex>
                <v-text-field label="Alícuota" v-if="p.alicuota" v-model="p.alicuota.desig" readonly></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex>
                <v-text-field label="Fecha de necesidad" :value="p.fecha_necesidad | fecha" readonly></v-text-field>
              </v-flex>
              <v-flex>
                <v-text-field label="Fecha de entrega" :value="p.fecha_entrega | fecha" readonly></v-text-field>
              </v-flex>
              <v-flex>
                <v-text-field label="Plazo de entrega" :value="p.plazo_entrega" readonly></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex class="text-xs-center">
                <div v-if="!loadingPedidos" class="title">Pedidos de venta vinculados</div>
                <template v-for="p in pedidos">
                  <template v-for="pv in p.pedidos">
                    <v-chip @click="pedidoMostrar(p.emp.id,pv)">
                      <v-avatar>
                        <img :src="p.emp.avatar"/>
                      </v-avatar>
                      {{ pv }}
                    </v-chip>
                  </template>
                </template>
                <v-progress-circular indeterminate color="primary" v-if="loadingPedidos"></v-progress-circular>
                <br>
                <v-divider></v-divider>
                <br>
                <div v-if="!loadingFacturas" class="title">Facturas vinculadas</div>
                <template v-for="p in facturas">
                  <template v-for="f in p.facturas">
                    <v-chip>
                      <v-avatar>
                        <img :src="p.emp.avatar"/>
                      </v-avatar>
                      {{ f.F2_SERIE }}-{{ f.F2_DOC }}
                    </v-chip>
                  </template>
                </template>
                <v-progress-circular indeterminate color="primary" v-if="loadingFacturas"></v-progress-circular>
                <br>
                <v-divider></v-divider>
                <br>
                <div v-if="!loadingRemitos" class="title">Remitos vinculados</div>
                <template v-for="p in remitos">
                  <template v-for="f in p.remitos">
                    <v-chip>
                      <v-avatar>
                        <img :src="p.emp.avatar"/>
                      </v-avatar>
                      {{ f.D2_SERIE }}-{{ f.D2_DOC }}
                    </v-chip>
                  </template>
                </template>
                <v-progress-circular indeterminate color="primary" v-if="loadingRemitos"></v-progress-circular>
              </v-flex>
              <v-divider class="mx-3" inset vertical></v-divider>
              <v-flex>
                <v-layout class="text-xs-center" align-content-center>
                  <v-flex>
                    <div v-if="!loadingProgreso" class="title">Progreso del presupuesto</div>
                    <br>
                    <presup-progreso :porcentaje="progreso" width="15" size="100" rotate="-90"></presup-progreso>
                  </v-flex>
                  <v-flex>
                    <div class="title">Probabilidad de cierre</div>
                    <br>
                    <probabilidad :porcentaje="(p.probabilidad)? p.probabilidad : 0" width="15" size="100" rotate="-90"
                                  :presupuesto="p.id"></probabilidad>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-tooltip top>
              <v-btn slot="activator" dark icon flat color="blue" @click.stop="fleteDialogShow" :loading="fleteLoading">
                <v-icon>local_shipping</v-icon>
              </v-btn>
              <span>Cálculo de flete</span>
            </v-tooltip>
            <v-spacer></v-spacer>
            <v-tooltip top>
              <v-btn slot="activator" dark icon flat color="blue" :to="'/presupuesto/edit/' + p.id">
                <v-icon>edit</v-icon>
              </v-btn>
              <span>Edición de encabezado</span>
            </v-tooltip>
            <v-tooltip top>
              <v-btn slot="activator" dark icon flat color="orange"
                     @click.native="$router.push({name:'historia',params:{presup: p.id}})">
                <v-icon>history</v-icon>
              </v-btn>
              <span>Historia del presupuesto</span>
            </v-tooltip>
            <v-tooltip top>
              <v-btn slot="activator" dark icon flat color="blue" @click.native="pdfAbre()">
                <v-icon>print</v-icon>
              </v-btn>
              <span>Impresion del presupuesto</span>
            </v-tooltip>
          </v-card-actions>
        </v-card>
        <br>
        <v-card raised>
          <v-card-title>
            <h3 class="headline mb-0">Datos del Cliente</h3>
          </v-card-title>
          <v-card-text>
            <v-layout row wrap v-if="p.cliente">
              <v-flex>
                <v-text-field label="CUIT" v-model="p.cliente.cuit" readonly mask="##-########-#"></v-text-field>
              </v-flex>
              <v-flex>
                <v-text-field label="Razón Social" v-model="p.cliente.rzon_soc" readonly></v-text-field>
              </v-flex>
              <v-flex>
                <v-text-field label="Teléfono" v-model="p.cliente.tel" readonly></v-text-field>
              </v-flex>
              <v-flex>
                <v-text-field label="Email" v-model="p.cliente.email" readonly></v-text-field>
              </v-flex>
              <v-flex>
                <v-text-field label="Dirección" v-model="p.cliente.dir" readonly></v-text-field>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
        <br>
        <!--////////////////////////////////////////////////////////////////////////////////////////-->
        <template v-for="t in tipos">
          <tabla-items :color="t.color" :tipo="t.cod" :presup="$route.params.id" :moneda="p.moneda_id"
                       :titulo="t.desig"></tabla-items>
        </template>
        <!--////////////////////////////////////////////////////////////////////////////////////////-->
        <v-container grid-list-lg fluid>
          <template v-for="t in totales">
            <v-layout row wrap>
              <v-flex>
                <h1 class="display-3 text-xs-right">Total {{ t.desig }}</h1>
              </v-flex>
              <v-flex>
                <h1 class="display-3 text-xs-right">{{ t.total | moneda(p.moneda_id) }}</h1>
              </v-flex>
            </v-layout>
          </template>
          <v-divider></v-divider>
          <v-layout row wrap>
            <v-flex>
              <h1 class="display-3 text-xs-right">Total Presupuesto</h1>
            </v-flex>
            <v-flex>
              <h1 class="display-3 text-xs-right">{{ total | moneda(p.moneda_id) }}</h1>
            </v-flex>
          </v-layout>
        </v-container>
        <!--////////////////////////////////////////////////////////////////////////////////////////-->
        <v-speed-dial direction="top" fixed bottom right v-model="fab">
          <v-btn slot="activator" v-model="fab" color="red darken-2" dark fab>
            <v-icon>build</v-icon>
            <v-icon>close</v-icon>
          </v-btn>
          <v-btn color="blue" small dark fab @click.stop="sheetNuevoItem = true">
            <v-icon>add</v-icon>
          </v-btn>
          <v-btn color="green" small dark fab @click.stop="validaConfirmacionDialog = true">
            <v-icon>fa-check-circle</v-icon>
          </v-btn>
          <v-btn color="purple" small dark fab @click.stop="descuentoDialog = true">
            <v-icon>fa-gift</v-icon>
          </v-btn>
        </v-speed-dial>
        <!--////////////////////////////////////////////////////////////////////////////////////////-->
      </v-flex>
    </v-layout>
    <!--/////////////////////////////NUEVO ITEM///////////////////////////////////////////////////////////-->
    <v-bottom-sheet v-model="sheetNuevoItem">
      <v-list>
        <v-subheader>Nuevo item</v-subheader>
        <template v-for="t in tipos">
          <v-list-tile @click="$router.push({name: 'presup.'+ t.cod + '.add',params:{presup: p.id,oper:'add'}})">
            <v-list-tile-action>
              <v-icon :color="t.color">add</v-icon>
            </v-list-tile-action>
            <v-list-tile-title>{{ t.desig }}</v-list-tile-title>
          </v-list-tile>
        </template>
      </v-list>
    </v-bottom-sheet>
    <v-dialog v-model="validaConfirmacionDialog" max-width="290">
      <v-card>
        <v-card-title class="headline text-xs-center">¿Desea confirmar todos los items del presupuesto?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" flat="flat" @click="validaConfirmacionDialog = false">
            Cancelar
          </v-btn>
          <v-btn color="green darken-1" flat="flat" @click="confirmar()">
            Aceptar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--/////////////////////////////DIALOG DE PEDIDO DE VENTA///////////////////////////////////////////////////////////-->
    <pedido-venta-dialog v-model="pedidoVentaDialog" :emp="pedido.emp" :pedido="pedido.id"></pedido-venta-dialog>
    <!--/////////////////////////////DIALOG DESCUENTO///////////////////////////////////////////////////////////-->
    <v-dialog v-model="descuentoDialog" max-width="500">
      <v-card>
        <v-card-title primary-title class="headline grey lighten-2">Ingrese los porcentajes</v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout row wrap>
              <v-flex>
                <v-text-field label="Descuento comercial"
                              v-model="descuento_com"
                              hint="Porcentaje máximo que desea aplicar"
                              persistent-hint></v-text-field>
              </v-flex>
              <v-flex>
                <v-text-field label="Descuento estratégico" v-model="descuento_est"
                              hint="Porcentaje máximo que desea aplicar"
                              persistent-hint></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex>
                <v-checkbox v-model="adiciona" label="¿Adicionar descuento a los preexistentes?"></v-checkbox>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" flat @click="descuentoDialog=false">Cancelar</v-btn>
          <v-btn color="green" flat @click="descuentoAplica()">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--/////////////////////////////DIALOG FLETE///////////////////////////////////////////////////////////-->
    <v-dialog v-model="fleteDialog" max-width="500" scrollable>
      <v-card>
        <v-card-title primary-title class="headline grey lighten-2">¿Adicionar flete?</v-card-title>
        <v-card-text>
          <v-list>
            <v-list-tile>
              <v-list-tile-content v-if="flete.txt">
                <v-list-tile-title><b>Mensaje: </b> {{ flete.txt }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile>
              <v-list-tile-content>
                <v-list-tile-title><b>Cant camiones: </b> {{ flete.camiones }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile>
              <v-list-tile-content>
                <v-list-tile-title><b>Distancia: </b> {{ flete.distancia | moneda }} km</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile>
              <v-list-tile-content>
                <v-list-tile-title><b>Alicuota: </b> {{ flete.alicuota | moneda }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile>
              <v-list-tile-content>
                <v-list-tile-title><b>Valor del flete: </b>U$S {{ flete.costoFlete | moneda }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile>
              <v-list-tile-content>
                <v-list-tile-title><b>Total seguro: </b>U$S {{ flete.seguroTot | moneda }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile>
              <v-list-tile-content>
                <v-list-tile-title><b>Total: </b>U$S {{ flete.total | moneda }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" flat @click.stop="fleteDialog = false">Cancelar</v-btn>
          <v-btn color="green" flat @click="fleteAgrega" :loading="fleteAddLoading">Agregar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import filterFecha from '../../filters/fecha';
import tablaItems from '../../components/TablaItems';
import pedidoVentaDialog from '../../components/PedidoVentaDialog';
import PresupProgreso from '../../components/PresupProgreso';
import Probabilidad from '../../components/Probabilidad';
import mixinPresup from '../../mixins/presupuesto';
import mixinPresupItem from '../../mixins/presupuestoItems';
import mixinFletePrecio from '../../mixins/flete_precio';
import mixinFleteSeguro from '../../mixins/flete_seguro';
import mixinItems from '../../mixins/items';
import moneda from '../../filters/moneda';
import monedaTxt from '../../filters/monedaTxt';
import fechaMicro from '../../filters/fecha-micro';
import {mapActions} from 'vuex';
import axios from 'axios';
import store from '../../store/index';

export default {
  name: "add",
  $_veeValidate: {
    validator: 'new'
  },
  mixins: [mixinPresup, mixinPresupItem, mixinItems, mixinPresupItem, mixinFletePrecio, mixinFleteSeguro],
  filters: {moneda, fecha: filterFecha, fechaMicro, monedaTxt},
  components: {tablaItems, PresupProgreso, pedidoVentaDialog, Probabilidad},
  data() {
    return {
      adiciona: false,
      descuento_com: '',
      descuento_est: '',
      descuentoDialog: false,
      validaConfirmacionDialog: false,
      presupuesto_id: this.$route.params.id,
      fab: false,
      p: {
        id: '',
      },
      progreso: 0,
      c: {
        rzon_soc: '',
        tel: '',
        dir: '',
        email: ''
      },
      pedidos: [],
      facturas: [],
      remitos: [],
      tipos: [],
      totales: [],
      pedido: {
        emp: '',
        id: ''
      },
      sheetNuevoItem: false,
      loadingProgreso: false,
      loadingPedidos: false,
      loadingFacturas: false,
      loadingRemitos: false,
      pedidoVentaDialog: false,
      fleteLoading: false,
      fleteDialog: false,
      fleteAddLoading: false,
      flete: {costoFlete: 0, txt: '', camiones: '', precioUnit: 0, distancia: 0, alicuota: 0, seguroTot: 0, total: 0},
      puertasSalida: [
        {id: 1, desig: 'MENDOZA'},
        {id: 2, desig: 'BUENOS AIRES'},
      ],
    }
  },
  computed: {
    total() {
      return this.totales.reduce((a, b) => {
        return a + b.total;
      }, 0)
    },
    puerta_salida() {
      if (this.p.puerta_salida) {
        return this.puertasSalida.find(i => i.id === this.p.puerta_salida).desig
      } else {
        return 'SIN ASIGNAR';
      }
    }
  },
  mounted() {
    this.$bus.$on('cambioEstado', () => {
      this.presupuestoViewUpdate();
    });
  },
  beforeRouteUpdate(to, from, next) {
    this.progresoShow({indeterminate: true, msj: 'Obteniendo datos del presupuesto...'});
    this.$http.get('presupuesto/' + to.params.id)
        .then(r => {
          if (r.data.tipo === 'error' || r.data.tipo === 2) {
            this.msjShow(r.data);
            this.progresoHide();
            next(false);
          } else {
            this.presupShow(r.data);
            next();
          }
        })
        .catch(err => {
          this.progresoHide();
        });
  },
  beforeRouteEnter(to, from, next) {
    store.dispatch('progreso/progresoShow', {indeterminate: true, msj: 'Obteniendo datos del presupuesto...'});
    axios.get('presupuesto/' + to.params.id)
        .then(r => {
          if (r.data.tipo === 'error' || r.data.tipo === 2) {
            store.dispatch('notif/msjShow', r.data);
            store.dispatch('progreso/progresoHide');
            store.dispatch('loading/setActive', false);
            next(false);
          } else {
            next(vm => {
              vm.presupShow(r.data)
            })
          }
        })
        .catch(err => {
          store.dispatch('progreso/progresoHide');
        });

  },
  beforeDestroy() {
    this.$bus.$off('cambioEstado');
  },
  methods: {
    ...mapActions('notif', ['msjShow']),
    ...mapActions('progreso', ['progresoShow', 'progresoHide']),
    fleteDialogShow() {
      this.fleteLoading = true;
      this.fletePrecioTotal({presupuesto_id: this.p.id}, r => {
        this.flete = r;
        this.fleteLoading = false;
        this.fleteDialog = true;
      }, err => {
        this.fleteLoading = false;
        console.error(err)
      })
    },
    fleteAgrega() {
      if (!this.flete.total) {
        return false;
      }
      this.fleteAddLoading = true;
      this.presupuestoItemStore({
        'item_tipo_id': 9,
        'item_id': 2659,//flete segun distancia
        'cant': 1,
        'presupuesto_id': this.p.id,
        'pu': this.flete.total,
        'subtotal': this.flete.total,
        'empresa_id': 1,
        'ubicacion': 'M',
      }, r => {
        this.fleteAddLoading = false;
        this.fleteDialog = false;
        this.msjShow(r);
        this.presupuestoViewUpdate()
      }, e => {
        this.msjShow({
          txt: 'Error de validación',
          tipo: 'error',
          errores: (e.response.data.errors) ? e.response.data.errors : ''
        });
        this.fleteAddLoading = false;
      })
    },
    fleteQuita() {
      this.presupuestoItemFleteQuita({presupuesto_id: this.p.id}, r => {
        this.msjShow(r);
        this.fleteDialog = false;
      }, err => console.error(err));
    },
    presupuestoViewUpdate() {
      this.progresoShow({indeterminate: true, msj: 'Obteniendo datos del presupuesto...'});
      this.$http.get('presupuesto/' + this.$route.params.id)
          .then(r => {
            if (r.data.tipo === 'error' || r.data.tipo === 2) {
              this.msjShow(r.data);
              this.progresoHide();
            } else {
              this.presupShow(r.data);
            }
          })
          .catch(err => {
            this.progresoHide();
          });
    },
    descuentoAplica() {
      this.progresoShow({indeterminate: true, msj: 'Obteniendo datos del presupuesto...'});
      this.presupuestoItemDescuentoGlobal({
        descuento_com: this.descuento_com,
        descuento_est: this.descuento_est,
        adiciona: this.adiciona,
        presupuesto_id: this.p.id
      }, r => {
        this.msjShow(r);
        this.presupuestoTotales({presupuesto_id: this.p.id},
            r => {
              this.totales = r;
            }, err => {
              console.log('Error al traer totales', err)
            });
        this.$nextTick(() => {
          this.$bus.$emit('actualizarTablaItems', this.p.id)
        });
        this.descuentoDialog = false;
        this.progresoHide();
      }, err => {
        this.msjShow({txt: 'Error al aplicar descuento', tipo: 2});
        this.progresoHide();
      })
    },
    pdfAbre() {
      // this.presupuestoFleteRecalcula({presupuesto_id: this.presupuesto_id}, r => {
      //     if (!r) {
      window.open(window.Laravel.urlBase + '/presupuesto/pdf?presup=' + this.presupuesto_id, '_blank');
      // } else {
      //     this.fleteDialog = true;
      // }
      // }, err => console.log(err));
    },
    presupShow(r) {
      this.p = r.p;
      this.loadingPedidos = true;
      this.loadingFacturas = true;
      this.loadingRemitos = true;
      this.presupuestoPedidos({presupuesto_id: this.p.id},
          r => {
            this.pedidos = r;
            this.loadingPedidos = false;
          }, err => {
            console.log('Error al traer pedidos', err)
            this.loadingPedidos = false;
          });
      this.presupuestoFacturas({presupuesto_id: this.p.id},
          r => {
            this.facturas = r;
            this.loadingFacturas = false;
          }, err => {
            console.log('Error al traer facturas', err)
            this.loadingFacturas = false;
          });
      this.presupuestoRemitos({presupuesto_id: this.p.id},
          r => {
            this.remitos = r;
            this.loadingRemitos = false;
          }, err => {
            console.log('Error al traer remitos', err)
            this.loadingRemitos = false;
          });
      this.presupuestoTotales({presupuesto_id: this.p.id},
          r => {
            this.totales = r;
          }, err => {
            console.log('Error al traer totales', err)
          });
      this.itemTipos(r => {
        this.tipos = r;
      }, err => {
        console.log(err)
      });
      this.presupProgreso();
      this.progresoHide();
      this.$nextTick(() => {
        this.$bus.$emit('actualizarTablaItems', this.p.id)
      })
    },
    presupProgreso() {
      this.loadingProgreso = true;
      this.$http.post('presupuesto/progreso', {presupuesto_id: this.presupuesto_id})
          .then(r => {
            this.progreso = r.data.porcent;
            this.loadingProgreso = false;
          })
          .catch(err => {
            this.loadingProgreso = false;
          })
    },
    confirmar() {
      this.validaConfirmacionDialog = false;
      this.progresoShow({indeterminate: true, msj: 'Obteniendo datos del presupuesto...'});
      this.presupuestoItemConfirma({presupuesto_id: this.presupuesto_id},
          r => {
            this.progresoHide();
            this.msjShow(r);
            this.$bus.$emit('actualizarTablaItems')
          }, err => {
            console.log(err);
            this.progresoHide();
          })
    },
    pedidoMostrar(emp, pedido) {
      this.pedido.emp = emp;
      this.pedido.id = pedido;
      this.pedidoVentaDialog = true;
    }

  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/presup/show.vue